import en from './locales/en.json'
import ro from './locales/ro.json'
import reducers from './redux/reducers'
import sagas from './redux/sagas'

export default {
  name: 'auth',
  routes: [
    {
      path: '/auth/login',
      async lazy() {
        const Comp = await import('./pages/login')
        return { Component: Comp.default }
      },
      // component: Loadable(() => import('./pages/login')),
      exact: true,
    },
    {
      path: '/auth/register',
      async lazy() {
        const Comp = await import('./pages/register')
        return { Component: Comp.default }
      },
      // component: Loadable(() => import('./pages/register')),
      exact: true,
    },
  ],
  locales: {
    en,
    ro,
  },
  reducers,
  sagas,
}
